import { render, staticRenderFns } from "./DriverPhotos.vue?vue&type=template&id=6aa3b924&"
import script from "./DriverPhotos.vue?vue&type=script&lang=js&"
export * from "./DriverPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports